var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJumbleQuestion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105,
    height: 15,
    viewBox: "0 0 105 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#2CABE0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-72 -1372) translate(60 1309) translate(12 63)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    x: 0.5,
    y: 0.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    x: 36.5,
    y: 0.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    x: 72.5,
    y: 0.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    x: 18.5,
    y: 0.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    x: 54.5,
    y: 0.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    x: 90.5,
    y: 0.5,
    rx: 1
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJumbleQuestion);
export default __webpack_public_path__ + "static/media/jumble-question.714a5f302021f5dcc375fa06b045d970.svg";
export { ForwardRef as ReactComponent };